//@flow
import InfoManager from "./InfoManager";
export { InfoManager };